import { render, staticRenderFns } from "./PlaylistCreateExercises.vue?vue&type=template&id=15fbe53d"
import script from "./PlaylistCreateExercises.vue?vue&type=script&lang=js"
export * from "./PlaylistCreateExercises.vue?vue&type=script&lang=js"
import style0 from "./PlaylistCreateExercises.vue?vue&type=style&index=0&id=15fbe53d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
